import { SetStateAction } from "react";

export interface ICreateJustificationAbsenceDto {
  UserID: number;
  PosCode: string;
  VisitScheduled: string;
  AbsenceTypeID: number;
}

export interface ICustomPropertiesFile {
  userIDConsultedData: number;
  startDate: string;
  endDate: string;
}

export interface IUploadJustificacationAbsencesDto {
  StartDate: string;
  EndDate: string;
  UserIDConsultedData: number;
  JustificationAbsences: ICreateJustificationAbsenceDto[];
}

export interface IResponseCreateJustificationAbsencesDto {
  userID: number;
  advisor: string;
  posCode: string;
  appointmentDate: string;
  result: number;
  message: string;
}

export interface TableColumnsAbsences {
  advisorID: string;
  advisor: string;
  justificationAbsenceType: string;
  posCode: string;
  scheduledAppointmentDate: string;
  creationDate: string;
  modificationDate: string;
  deleted: string;
}

export const initialValuesSearch: TableColumnsAbsences = {
  advisorID: "",
  advisor: "",
  justificationAbsenceType: "",
  posCode: "",
  scheduledAppointmentDate: "",
  creationDate: "",
  modificationDate: "",
  deleted: ""
};

export interface IJustificationAbsenceDto {
  idJustificationAbsence: number;
  justificationAbsenceTypeID: number;
  advisorID: number;
  advisor: string;
  justificationAbsenceType: string;
  posCode: string;
  scheduledAppointmentDate: string;
  creationDate: string;
  modificationDate: string;
  deleted: boolean;
}

export interface IValuesGraph {
  totalAbsencesCount: number;
  totalJustificationsCount: number;
}

export interface IJustificationAbsencesAndCountsDto {
  justifications: IJustificationAbsenceDto[];
  totalAbsencesCount: number;
  totalJustificationsCount: number;
}

export interface IFormUpdateValues {
  idJustificationAbsence: number,
  advisorID: number,
  advisor: string,
  justificationAbsenceType: number[],
  posCode: string,
  scheduledAppointmentDate: string
}

export const initialFormUpdateValues: IFormUpdateValues = {
  idJustificationAbsence: 0,
  advisorID: 0,
  advisor: "",
  justificationAbsenceType: [],
  posCode: "",
  scheduledAppointmentDate: ""
};

export interface IJustificationAbsenceTypesDto {
  idTypeAbsence: number;
  absence: string;
}

export interface IUpdateJustificationAbsenceDto {
  IDJustificationAbsence: number;
  JustificationAbsenceTypeID: number;
}

export interface IPropsComponentesTab {
  setLoadingModal: React.Dispatch<SetStateAction<boolean>>,
  setLoading: React.Dispatch<SetStateAction<boolean>>,
  setOpenModalError: React.Dispatch<SetStateAction<boolean>>,
  setMessageModalError: React.Dispatch<SetStateAction<string>>,
  setOpenModalMessage: React.Dispatch<SetStateAction<boolean>>,
  setMessageModalMessage: React.Dispatch<SetStateAction<string>>,
  loading: boolean,
  callBackOnChangeTab: (value: number) => void,
}